import React, { useState, useCallback, forwardRef } from 'react';
import { CreateTableNew as CreateTable, GeneralMessage } from '../../../../../common/APICommon';
import { LoadingSpinner } from '../../../../../common/Loading';
import { useEmployeeLeaveBalance } from '../../../../hooks/useEmployeeLeaveBalance';
import EditIcon from '@mui/icons-material/Edit';
import LeaveCreditsTabAddEditModal from './components/LeaveCreditsTabAddEditModal';
import { isCellExitEditModeKeys } from '@mui/x-data-grid/utils/keyboardUtils';

export const LeaveCreditsTab = forwardRef(({ employeePersonalInformationId, isEditMode }, ref) => {
  console.log({ isEditMode });
  const {
    employeeLeaveCredits,
    currentYear, // ADDED
    selectedEmployeeLeaveCredit, setSelectedEmployeeLeaveCredit,
    showMessage, message, isSuccess,
    updateLocalBalance, // Now available again
    executeSave,
    loading
  } = useEmployeeLeaveBalance(employeePersonalInformationId);

  const [currentPage, setCurrentPage] = useState(1);
  const [isCreditsTabAddEditModalOpen, setIsCreditsTabAddEditModalOpen] = useState(false);

  const resetEmployeeLeaveCreditVariables = () => {
    setSelectedEmployeeLeaveCredit(null);
  }

  const handleEditEmployeeLeaveCreditModal = (item) => {
    setSelectedEmployeeLeaveCredit(item);
    setIsCreditsTabAddEditModalOpen(true);
  };

  const handleCloseEmployeeLeaveCreditModal = () => {
    setIsCreditsTabAddEditModalOpen(false);
    resetEmployeeLeaveCreditVariables();
  };

  const handleSave = (formData) => {
    // Optimistic UI update
    updateLocalBalance(formData.leaveTypeId, "totalLeaveCredit", formData.totalLeaveCredit);
    updateLocalBalance(formData.leaveTypeId, "remainingLeaveCredit", formData.remainingLeaveCredit);

    executeSave(formData);
  }

  const headers = [
    "Leave Type",
    "Total Credits",
    "Remaining",
    "Encashable",
    "Tax Treatment",
    ...(isEditMode ? ["Actions"] : []),
  ];
  const accessors = [
    "leaveTypeDescription",
    "totalLeaveCredit",
    "remainingLeaveCredit",
    "isEncashable",
    "taxTreatmentName",
    ...(isEditMode ? ["actions"] : []),
  ];

  const customCellRenderer = useCallback((row, accessor) => {
    if (accessor === "isEncashable") {
      return <div className="text-xs text-gray-500">{row.isEncashable ? `Yes (${row.maxEncashableDays} days)` : "No"}</div>;
    }

    if (accessor === "taxTreatment") {
      return <div className="text-xs text-gray-500">{row.taxTreatmentName || "—"}</div>;
    }
    return null;
  }, []);

  const actions = [
    {
      name: "Edit",
      // MODIFIED: Visual feedback if year is missing
      tooltip: currentYear ? "Edit Leave Credits" : "Payroll Year not configured",
      icon: <EditIcon fontSize="small" />,
      className: `${currentYear ? "bg-green-500 hover:bg-green-600" : "bg-gray-400 grayscale cursor-not-allowed"} flex items-center`,
      function: (item) => {
        if (!currentYear) return;
        handleEditEmployeeLeaveCreditModal(item);
      },
      visible: isEditMode,
    }
  ];

  return (
    <>
      <div className="family-tab-body">
        <div className="employeesTab-table container">
          <CreateTable
            tableName={"EmployeeLeaveCredits"}
            headers={headers}
            accessors={accessors}
            data={employeeLeaveCredits}
            actions={actions}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={10}
            totalItems={employeeLeaveCredits?.length}
            customCellRenderer={customCellRenderer}
          />
        </div>
      </div>

      {isCreditsTabAddEditModalOpen && (
        <LeaveCreditsTabAddEditModal
          isOpen={isCreditsTabAddEditModalOpen}
          onClose={handleCloseEmployeeLeaveCreditModal}
          selectedItem={selectedEmployeeLeaveCredit}
          onSave={(formData) => {
            handleSave(formData);
            setIsCreditsTabAddEditModalOpen(false);
          }}
        />
      )}

      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />
      <LoadingSpinner loading={loading} />
    </>
  );
});